export default __webpack_public_path__ + "static/media/reading.20343e55.svg";